import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import noop from 'lib/function/noop'
import React, { useCallback } from 'react'

interface Props {
  airport: App.AirportLocation;
  onClick?: (airport: App.AirportLocation) => void;
  selected?: boolean;
}

function OfferAirportSelectOption(props: Props) {
  const { airport, onClick = noop, selected, ...rest } = props

  const onAirportSelect = useCallback(() => {
    onClick(airport)
  }, [airport, onClick])

  return <ClickableListItem
    {...rest}
    size="large"
    startIcon={<LinePlaneDepartureIcon />}
    title={airport.airportName}
    subtitle={airport.airportCode}
    onClick={onAirportSelect}
    selected={selected}
  />
}

export default OfferAirportSelectOption
